import { useQuery } from "@tanstack/react-query";

import { useApi } from "@/shared/api/use-api";

const JOB_TYPE_HH_EXPORT = "HH_EXPORT";

type Params = {
  userId?: number;
  pageNumber: number;
  pageSize: number;
};

export const useGetHandExportJobs = ({ userId, pageNumber, pageSize }: Params) => {
  const { statsControllerApi } = useApi();

  return useQuery({
    queryKey: [`listBackgroundJobs`, JOB_TYPE_HH_EXPORT, userId, pageNumber, pageSize],
    queryFn: ({ signal }) =>
      statsControllerApi.listBackgroundJobs(userId, JOB_TYPE_HH_EXPORT, pageNumber, pageSize, {
        signal,
      }),
    refetchInterval: 10000,
  });
};
